import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../../../navigators';
import {SuccessTemplate} from '../../../../../../components/templates/success';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../../components/buttons';
import {message} from '../../../../../../utils/messages';
import {useSalesmanContext} from '../../../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanOrderSuccess'
>;

const SalesmanOrderSuccessScreen = ({navigation}: ScreenProps) => {
  const {
    client,
    customerOrder,
    createSalesmanNewOrder: createOrder,
    updateSalesmanNewOrder: updateOrder,
    clearSalesmanProducts,
  } = useSalesmanContext();

  const clearWorkflow = () => {
    updateOrder(null);
    clearSalesmanProducts();
  };

  const handlePrimaryPress = () => {
    if (client) {
      const popScreens = customerOrder?.transport ? 3 : 2;
      clearWorkflow();
      navigation.pop(popScreens);
    }
  };

  const handleSecondaryPress = () => {
    handlePrimaryPress();
    createOrder(client!);
    navigation.navigate('SalesmanOrderBegin', {fromTemplate: false});
  };

  return (
    <SuccessTemplate
      title={message('salesman-order-success-title')}
      summary={message('salesman-order-success-summary')}>
      <PrimaryButton
        label={message('salesman-order-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('salesman-order-success-secondary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </SuccessTemplate>
  );
};
export default SalesmanOrderSuccessScreen;
